import React, { useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, useGetList, useQuery } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CreateIcon from '@material-ui/icons/Create';
import Box from '@material-ui/core/Box';

import { ServiceAreaProvider } from '../../Context';
import ServiceVehicleEdit from './ServiceVehicleEdit';
import MapView from './MapView';
import MapEdit from './MapEdit';
import { pickColor } from '../../helper';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export const ServiceAreaList = () => {
  const classes = useStyles();
  const [toggleAllVehicles, setToggleAllVehicles] = useState(true);
  const [selectedVehicles, setSelectedVehicles] = useState(null);
  const serviceVehicles = useGetList(
    'service-vehicle',
    { page: 1, perPage: 1000 },
    { field: 'name', order: 'ASC' },
    { is_active: true, is_service_bay: false },
  );
  const { ids = [], data } = serviceVehicles;
  if (!selectedVehicles) {
    if (Object.keys(data).length > 0) {
      setSelectedVehicles(Object.keys(data));
    }
  }
  const handleCheckbox = (id) => {
    if (selectedVehicles.includes(id)) {
      const index = selectedVehicles.indexOf(id);
      const temp = [...selectedVehicles];
      temp.splice(index, 1);
      setSelectedVehicles(temp);
    } else {
      setSelectedVehicles([...selectedVehicles, id]);
    }
  };
  const handleToggleAll = () => {
    if (toggleAllVehicles) {
      setToggleAllVehicles(false);
      setSelectedVehicles([]);
    } else {
      setToggleAllVehicles(true);
      setSelectedVehicles(Object.keys(data));
    }
  };
  if (!selectedVehicles) {
    return 'Loading...';
  }
  return (
    <ServiceAreaProvider
      value={{
        data,
        selectedVehicles,
        setSelectedVehicles,
      }}
    >
      <div className={classes.root}>
        <Box mt={2}>
          <Grid container spacing={3}>
            <Grid item lg={3} sm={12} xs={12}>
              <Paper className={classes.paper}>
                <FormGroup column="true">
                  <Box display="flex" alignItems="center">
                    <Button />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={toggleAllVehicles}
                          onChange={handleToggleAll}
                        />
                      }
                      label={`${
                        toggleAllVehicles ? 'Deselect all' : 'Select all'
                      }`}
                    />
                  </Box>
                </FormGroup>
                <FormGroup column="true">
                  {ids.map((id) => (
                    <Box key={id} display="flex" alignItems="center">
                      <Button
                        component={Link}
                        to={{
                          pathname: `/service-area/${id}`,
                        }}
                      >
                        <CreateIcon />
                      </Button>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={selectedVehicles.includes(id)}
                            onChange={() => handleCheckbox(id)}
                          />
                        }
                        label={
                          <span style={{ color: `${pickColor(id)}` }}>
                            {data[id]?.name}
                          </span>
                        }
                      />
                    </Box>
                  ))}
                </FormGroup>
              </Paper>
            </Grid>
            <Grid item lg={9} sm={12} xs={12}>
              <Paper className={classes.paper}>
                <div className="mapWrapper">
                  {selectedVehicles && <MapView />}
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </div>
    </ServiceAreaProvider>
  );
};

export const ServiceAreaEdit = (props) => {
  const { id: service_vehicle_id } = useParams();
  const portalRef = useRef(null);
  const classes = useStyles();
  const [serviceVehicle, setServiceVehicle] = useState(null);
  const [editServiceAreas, setEditServiceAreas] = useState(null);
  const { data } = useQuery({
    type: 'getList',
    resource: 'service-vehicle',
    payload: {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'name', order: 'ASC' },
      filter: { is_active: true, is_service_bay: false },
    },
  });
  return (
    <ServiceAreaProvider
      value={{
        data,
        serviceVehicle,
        setServiceVehicle,
        editServiceAreas,
        setEditServiceAreas,
        portalRef,
      }}
    >
      <div className={classes.root}>
        <Box mt={2}>
          <Grid container spacing={3}>
            <Grid item lg={3} sm={12} xs={12}>
              <Paper className={classes.paper}>
                <FormGroup column="true">
                  {data?.map((datum) => (
                    <Box key={datum.id} display="flex" alignItems="center">
                      <Button
                        component={Link}
                        to={{
                          pathname: `/service-area/${datum.id}`,
                        }}
                      >
                        <CreateIcon />
                      </Button>
                      <FormControlLabel
                        disabled={
                          service_vehicle_id && service_vehicle_id !== datum.id
                        }
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              (service_vehicle_id &&
                                service_vehicle_id === datum.id) ||
                              !service_vehicle_id
                            }
                          />
                        }
                        label={
                          <span style={{ color: `${pickColor(datum.id)}` }}>
                            {datum.name}
                          </span>
                        }
                      />
                    </Box>
                  ))}
                </FormGroup>
              </Paper>
            </Grid>
            <Grid item lg={9} sm={12} xs={12}>
              <Paper ref={portalRef} />
              <Paper className={classes.paper}>
                <div className="mapWrapper">
                  {serviceVehicle && <MapEdit />}
                </div>
                <ServiceVehicleEdit {...props} />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </div>
    </ServiceAreaProvider>
  );
};
